import React from "react";
import TransparentBackgroundStyled from "./transparentBackgroundStyled";

export default function TransparentBackground() {
  return <TransparentBackgroundStyled></TransparentBackgroundStyled>;
}
